import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingPage, useAuth } from "../../sdk";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import {
  Close,
  Download,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  Chip,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled, useMediaQuery } from "@mui/system";
import {
  ButtonContainer,
  HotelSection,
  Link,
  Main,
  OrganizationSection,
  Page,
} from "./Styles";
import { TextField as TF } from "@mui/material";
import { AddOutlined } from "@mui/icons-material";
import { Stack, TableHead, Breadcrumbs } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { RateComparsion } from "../../ChooseHotel";
import moment from "moment";
import DatePicker from "react-modern-calendar-datepicker";
import { CalenderIcon } from "../../AdminEvents";
import { useDebounceValue } from "../../sdk/hooks/useDebounceValue";
import ConfirmationDialog from "../../PrimarySetups/components/ConfirmationDialog";
import { LoadingButton } from "@mui/lab";

export const StyledCalenderWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  position: "relative",
  boxShadow: "0px 0px 4px  rgba(48, 111, 188, 0.2)",
  "&:hover>*": {
    color: "#ffffff",
    ">input": {
      backgroundColor: "#306fbc",
      color: "#ffffff !important",
    },
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  width: "200px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const SwitchStack = styled(Stack)(({ theme }) => ({
  padding: "2px",

  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const CustomButtonContainer = styled(ButtonContainer)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const CustomMain = styled(Main)(({ theme }) => ({
  height: "10%",
  padding: "24px 0px 24px 0px",
  [theme.breakpoints.down("sm")]: {
    paddingTop: "70px",
  },
}));

const StyledSearchIcon = styled(SearchIcon)(({ theme }) => ({
  color: "#306FBC",
  position: "absolute",
  marginTop: "8px",
  justifyContent: "flex-end",

  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box style={{ display: "flex" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPage /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPage />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const CustomPage = styled(Page)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    padding: "15px",
  },
}));

const ClassWrapper = styled(Box)(({ theme }) => ({
  ".dropdownStyle": {
    borderRadius: 4,
    font: "normal normal normal 16px/20px Roboto",
  },
  ".table": {
    minWidth: 650,
  },
  ".header": {
    position: "sticky",
    top: 0,
  },
  ".rowHover": {
    "&:hover": {
      backgroundColor: "#E6E6FA !important",
      cursor: "pointer",
    },
  },
}));

export const Status = styled(Button)`
  text-transform: none;
  background: #c6f3d2;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #42ae40;
  padding: 4px 20px 4px 20px;
  width: 78px;
`;
export const LN = styled(Box)`
  height: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  color: #e13a3a;
`;
export const BOB = styled(Box)`
  height: 20px;

  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  color: #42ae40;
`;
const TableCellHeading = styled(TableCell)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  color: #000000;
`;

const TCell = styled(TableCell)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: #000000;
  text-align: -webkit-right;
`;
const Search = styled(Box)(({ theme }) => ({
  justifyContent: "flex-end",
  width: "300px",
  height: "40px",
  background: "#ffffff",
  boxShadow: "1px 2px 4px 1px rgba(48, 111, 188, 0.2)",
  borderRadius: "8px",
  marginRight: "22px",
  [theme.breakpoints.down("sm")]: {
    position: "relative",
    width: "150px",
    overflow: "hidden",
  },
}));

const SearchBox = styled(TF)`
  height: 20px;
  width: 253px;
  padding-left: 16px;
  padding-top: 8px;
  position: relative;
  input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #777777;
  }
`;

export const TopSection = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const HotelChain = styled(Box)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  margintop: 12px;
  color: #000000;
  width: 100%;
  padding-left: 22px;
`;
export const OrganizationContainer = styled(Box)`
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  cursor: pointer;
`;
const AddHotel = styled(Typography)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  color: #ffffff;
`;

const triggerFileDownload = async (response, filename) => {
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const formatDate = (date) =>
  `${date.year}-${date.month
    .toString()
    .padStart(2, "0")}-${date.day.toString().padStart(2, "0")}`;

export function ChooseHotels({
  selectedOrganizationName,
  setSelectedOrganizationName,
  selectedChainName,
  setSelectedChainName,
}) {
  const {
    hotels,
    token,
    authFetch,
    permission,
    selectHotel,
    updateHotels,
  } = useAuth();

  const theme = useTheme();
  const [Loading, setLoading] = useState();
  const { ORGID, CHAINID } = useParams();
  const [differentOrganization, setDifferentOrganization] = useState(false);
  const [hotelList, setHotelList] = useState([]);
  const [page, setPage] = React.useState(0);
  const [hotelCount, setHotelCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [active, setActive] = useState(true);
  const [searched, setSearched] = useState("");
  const debouncesearch = useDebounceValue(searched, 300);
  const [filter, setFilter] = useState([]);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState({
    open: false,
    hotelId: null,
  });
  const [isDownloadExcel, setIsDownloadExcel] = useState(false);
  const [
    isDownloadHotelDetailsExcel,
    setIsDownloadHotelDetailsExcel,
  ] = useState(null);
  const [dateNew, setDateNew] = useState({
    from: "",
    to: "",
  });

  const handleFilterChange = useCallback((event) => {
    const {
      target: { value },
    } = event;

    const selectedValues = typeof value === "string" ? value.split(",") : value;

    if (selectedValues.length === 0) {
      setFilter(selectedValues);
      return;
    }

    setFilter(selectedValues);
    setPage(0);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [selectedChain] = useState(() => {
    if (CHAINID) {
      return CHAINID;
    } else {
      return 0;
    }
  });
  const [selectedManagingOrganization] = useState(() => {
    if (ORGID) {
      return ORGID;
    } else {
      return 0;
    }
  });

  let listOfOrg = null,
    addHotel = null,
    deactivateHotel = null,
    FilterHotelsByDate = null;
  for (let key in permission) {
    if (permission.hasOwnProperty(key)) {
      if (permission[key].name === "listOfOrg") {
        listOfOrg = permission[key];
      }
      if (permission[key].name === "addHotel") {
        addHotel = permission[key];
      }
      if (permission[key].name === "deactivateHotel") {
        deactivateHotel = permission[key];
      }
      if (permission[key].name === "FilterHotelsByDate") {
        FilterHotelsByDate = permission[key];
      }
    }
  }

  useEffect(() => {
    if (!token) {
      return;
    }
    if (token) {
      hotelList.forEach((_, index) => {
        if (
          hotelList[index + 1] &&
          hotelList[index].organizationId !==
            hotelList[index + 1].organizationId
        ) {
          setDifferentOrganization(true);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  async function getHotels() {
    setLoading(true);

    const filterDateData =
      dateNew?.from && dateNew?.to
        ? `&start_date=${formatDate(dateNew.from)}&end_date=${formatDate(
            dateNew.to,
          )}`
        : dateNew?.from
        ? `&start_date=${formatDate(dateNew.from)}`
        : "";

    const filterParams = [
      filter.includes("RateShopEnabled") ? "&rateShopEnabled=true" : "",
      filter.includes("PreciumEnabled") ? "&preciumEnabled=true" : "",
      filter.includes("InnKeyEnabled") ? "&innkeyEnabled=true" : "",
      filter.includes("ChannelManagerEnabled")
        ? "&channelManagerEnabled=true"
        : "",
      filter.includes("UpcomingEventsEnabled")
        ? "&upcomingEventsEnabled=true"
        : "",
    ].join("");

    if (listOfOrg) {
      const { get } = await authFetch({
        path:
          `/managing-org/${selectedManagingOrganization}/chains/${selectedChain}/hotels/${
            active ? 1 : 0
          }?limit=${rowsPerPage > 0 ? rowsPerPage : ""}&page=${
            page + 1
          }&hotelName=${debouncesearch ?? ""}&order=desc` +
          filterDateData +
          filterParams,
      });
      const { data, error } = await get();
      if (data) {
        setHotelCount(data?.count);
        const sortedData = data?.hotels?.length
          ? data.hotels.sort((a, b) => (a.name > b.name ? 1 : -1))
          : [];
        setHotelList(sortedData);
        updateHotels();
      } else {
        console.log(error || "No data received");
        setHotelList([]);
      }
    } else {
      setHotelList(hotels || []);
      setHotelCount(hotels?.length);
    }

    setLoading(false);
  }

  useEffect(() => {
    if (!token) {
      return;
    }
    getHotels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    token,
    rowsPerPage,
    page,
    dateNew,
    selectedManagingOrganization,
    selectedChain,
    listOfOrg,
    debouncesearch,
    filter,
    active,
  ]);

  async function getChains() {
    setLoading(true);
    const { get } = await authFetch({
      path: `/managing-org/${selectedManagingOrganization}/chains`,
    });
    const { data } = await get();
    if (data) {
      if (CHAINID === "all") {
        setSelectedChainName("All");
      } else if (CHAINID === -1) {
        setSelectedChainName("Standalone");
      } else {
        const chainName = data.find((chain) => chain.id === CHAINID)?.name;
        if (chainName) {
          setSelectedChainName(chainName);
        }
      }
    }
    setLoading(false);
  }

  async function getManagingOrganization() {
    setLoading(true);
    const { get } = await authFetch({
      path: `/all-managing-org`,
    });
    const { data, error } = await get();
    if (data) {
      if (ORGID === "all") {
        setSelectedOrganizationName("All");
      } else if (ORGID === -1) {
        setSelectedOrganizationName("Standalone");
      } else {
        const orgName = data.find((org) => org.id === ORGID)?.name;
        if (orgName) {
          setSelectedOrganizationName(orgName);
        }
      }
    } else {
      console.log(error);
    }
    setLoading(false);
  }

  const downloadHotelDetailsExcel = useCallback(
    async (hotelId) => {
      if (!hotelId) return;
      setIsDownloadHotelDetailsExcel(hotelId);
      try {
        const { get } = await authFetch({
          path: `/download-setup?id=${hotelId}`,
        });

        const { response } = await get();
        await triggerFileDownload(response, "Hotel-Details.xlsx");
      } catch (err) {
        console.error("Error Downloading Hotel Details", err);
      } finally {
        setIsDownloadHotelDetailsExcel(null);
      }
    },
    [authFetch],
  );

  useEffect(() => {
    getManagingOrganization();
    getChains();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const requestSearch = (searchedVal) => {
    setSearched(searchedVal);

    setPage(0);
  };

  const formatInputValue = () => {
    if (dateNew) {
      let fromValue;
      if (dateNew?.from) {
        fromValue =
          `${
            dateNew.from.day < 10 ? "0" + dateNew.from.day : dateNew.from.day
          }` +
          "/" +
          `${
            dateNew.from.month < 10
              ? "0" + dateNew.from.month
              : dateNew.from.month
          }` +
          "/" +
          `${dateNew.from.year}`;
      }
      let toValue;
      if (dateNew?.to) {
        toValue =
          `${dateNew.to.day < 10 ? "0" + dateNew.to.day : dateNew.to.day}` +
          "/" +
          `${
            dateNew.to.month < 10 ? "0" + dateNew.to.month : dateNew.to.month
          }` +
          "/" +
          `${dateNew.to.year}`;
      }

      return `${fromValue ?? "Start Date"} - ${toValue ?? "End Date"}`;
    }
    return "";
  };

  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref}
      value={formatInputValue()}
      style={{
        textAlign: "left",
        marginBottom: "2px",
        fontSize: "12px",
        borderRadius: "10px",
        color: "#000000",
        outline: "none",
        height: "45px",
        border: "none",
        fontWeight: 500,
        font: "500 12px / 14px Roboto",
        cursor: "pointer",
        width: "220px",
        paddingLeft: "10px",
      }}
      className="my-custom-input-class"
    />
  );

  const cancelSearch = () => {
    setSearched("");
  };

  const handleDeactivateHotel = async (hotelId) => {
    const status = !active;
    const { del } = await authFetch({
      path: `/hotel/${hotelId}/toggle-hotel?status=${status}`,
    });
    await del();
    getHotels();
  };

  const showFileStatus = (isEnabled, hasFile, type) => {
    const text = !isEnabled ? "N/A" : hasFile ? "Uploaded" : "Pending";
    const color = !isEnabled ? "#aaaaaaff" : hasFile ? "#42AE40" : "#E13A3A";
    if (type === "bob") {
      return <BOB style={{ color }}>{text}</BOB>;
    } else if (type === "ln") {
      return <LN style={{ color }}>{text}</LN>;
    } else {
      return <></>;
    }
  };

  const downloadAllHotelDetailsExcel = useCallback(async () => {
    setIsDownloadExcel(true);
    const params = new URLSearchParams({
      hotelName: debouncesearch ?? "",
      rateShopEnabled: filter.includes("RateShopEnabled"),
      preciumEnabled: filter.includes("PreciumEnabled"),
      innkeyEnabled: filter.includes("InnKeyEnabled"),
      channelManagerEnabled: filter.includes("ChannelManagerEnabled"),
      upcomingEventsEnabled: filter.includes("UpcomingEventsEnabled"),
    });

    if (dateNew?.from) {
      params.append("start_date", formatDate(dateNew.from));
      if (dateNew.to) {
        params.append("end_date", formatDate(dateNew.to));
      }
    }

    const path = `/download-excel/managing-org/${selectedManagingOrganization}/chains/${selectedChain}/hotels/${
      active ? 1 : 0
    }?${params.toString()}`;
    try {
      const { get } = await authFetch({
        path,
      });
      const { response } = await get();
      await triggerFileDownload(response, "All-Hotel-Details.xlsx");
    } catch (error) {
      console.error("Error Downloading Hotel Details Excel", error);
    } finally {
      setIsDownloadExcel(false);
    }
  }, [
    active,
    authFetch,
    dateNew.from,
    dateNew.to,
    debouncesearch,
    filter,
    selectedChain,
    selectedManagingOrganization,
  ]);

  const renderServiceChips = useCallback((hotel) => {
    const chipConfig = [
      {
        key: "preciumV1",
        label: "V1",
        tooltip: "Precium V1",
        show: hotel?.isPreciumEnabled,
      },
      {
        key: "preciumV2",
        label: "V2",
        tooltip: "Precium V2",
        show: hotel?.version === "v2",
      },
      {
        key: "rateShopEnabled",
        label: "RS",
        tooltip: "Rate Shop",
        show: hotel?.rateShopEnabled,
      },
      {
        key: "isChannelManagerEnabled",
        label: "CM",
        tooltip: "Channel Manager",
        show: hotel?.isChannelManagerEnabled,
      },
      {
        key: "innKeyEnabled",
        label: "PMS",
        tooltip: "PMS Integration",
        show: hotel?.innKeyEnabled,
      },
      {
        key: "canViewUpcomingEvents",
        label: "UE",
        tooltip: "Upcoming Events",
        show: hotel?.canViewUpcomingEvents,
      },
    ];

    const chips = chipConfig
      .filter(({ show }) => show)
      .map(({ key, label, tooltip, sx }) => (
        <Tooltip key={key} title={tooltip} arrow placement="top">
          <Chip
            label={label}
            size="small"
            sx={{
              backgroundColor: "#E8F1FF",
              color: "#306FBC",
              fontWeight: 600,
              cursor: "pointer",
            }}
          />
        </Tooltip>
      ));

    if (chips.length === 0) {
      return (
        <Typography variant="body2" color="#777777">
          —
        </Typography>
      );
    }

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: "300px",
          margin: "0 auto",
        }}
      >
        {chips}
      </Box>
    );
  }, []);

  return (
    <ClassWrapper>
      <CustomPage>
        <HotelSection>
          <CustomMain>
            {listOfOrg ? (
              <Breadcrumbs
                separator="›"
                aria-label="breadcrumb"
                style={{ marginLeft: "20px" }}
              >
                <Link
                  style={{
                    color: "#303030",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                  to="/managing_organization"
                >
                  Home
                </Link>
                <Link
                  style={{
                    color: "#303030",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                  to={
                    "/managing_organization/" +
                    selectedManagingOrganization +
                    "/chain"
                  }
                >
                  {selectedOrganizationName}
                </Link>
                <Link
                  style={{
                    color: "#2F6FBC",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                  to={
                    "/managing_organization/" +
                    selectedManagingOrganization +
                    "/chain/" +
                    selectedChain +
                    "/choose_hotel"
                  }
                >
                  {selectedChainName}
                </Link>
              </Breadcrumbs>
            ) : (
              <Breadcrumbs
                separator="›"
                aria-label="breadcrumb"
                style={{ marginLeft: "20px" }}
              >
                <Link color="inherit" to="/choose_hotel">
                  Home
                </Link>
              </Breadcrumbs>
            )}

            <Stack
              direction="row"
              justifyContent={"flex-end"}
              alignItems="center"
              gap="8px"
            >
              {FilterHotelsByDate && (
                <Tooltip
                  arrow
                  placement="top"
                  title="Filter Hotels by Created Date"
                >
                  <StyledCalenderWrapper>
                    <DatePicker
                      value={dateNew}
                      onChange={(date) => {
                        setDateNew(date);
                        setPage(0);
                      }}
                      colorPrimaryLight="#91ABE9"
                      clearButton
                      colorPrimary="#163A90"
                      calendarPopperPosition="auto" // Set reference to DatePicker
                      calendarClassName="myCustomCalendar"
                      renderInput={renderCustomInput}
                    />
                    {(dateNew?.to || dateNew?.from) && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setDateNew({
                            from: "",
                            to: "",
                          });
                        }}
                        sx={{
                          background: "transparent",
                          right: "32px",
                          zIndex: 98,
                          top: "7%",
                          position: "absolute",
                        }}
                      >
                        <Close color="inherit" />
                      </IconButton>
                    )}
                    <CalenderIcon
                      sx={{ position: "absolute", right: "8px", top: "15%" }}
                    />
                  </StyledCalenderWrapper>
                </Tooltip>
              )}

              <CustomFormControl>
                <InputLabel id="demo-multiple-checkbox-label">
                  Filter
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={filter}
                  onChange={handleFilterChange}
                  input={
                    <OutlinedInput
                      sx={{
                        height: "45px",
                      }}
                      label="Filter"
                    />
                  }
                  renderValue={(selected) => {
                    return selected
                      .map((option) => {
                        return option.replace(/Enabled$/, " Enabled");
                      })
                      .join(", ");
                  }}
                >
                  <MenuItem key={"rateShopEnabled"} value={"RateShopEnabled"}>
                    <Checkbox
                      checked={filter.indexOf("RateShopEnabled") > -1}
                    />
                    <ListItemText primary={"RateShop Enabled"} />
                  </MenuItem>
                  <MenuItem key={"isPreciumEnabled"} value={"PreciumEnabled"}>
                    <Checkbox checked={filter.indexOf("PreciumEnabled") > -1} />
                    <ListItemText primary={"Precium Enabled"} />
                  </MenuItem>
                  <MenuItem key={"innKeyEnabled"} value={"InnKeyEnabled"}>
                    <Checkbox checked={filter.indexOf("InnKeyEnabled") > -1} />
                    <ListItemText primary={"PMS Interface Enabled"} />
                  </MenuItem>
                  <MenuItem
                    key={"channelManagerEnabled"}
                    value={"ChannelManagerEnabled"}
                  >
                    <Checkbox
                      checked={filter.indexOf("ChannelManagerEnabled") > -1}
                    />
                    <ListItemText primary={"Channel Manager Enabled"} />
                  </MenuItem>
                  <MenuItem
                    key={"upcomingEventsEnabled"}
                    value={"UpcomingEventsEnabled"}
                  >
                    <Checkbox
                      checked={filter.indexOf("UpcomingEventsEnabled") > -1}
                    />
                    <ListItemText primary={"Upcoming Events Enabled"} />
                  </MenuItem>
                </Select>
              </CustomFormControl>

              <SwitchStack direction={"row"}>
                <Typography style={{ marginTop: "5px", color: "#306FBC" }}>
                  {active ? "Active" : "Inactive"}
                </Typography>
                <Switch
                  checked={active}
                  onChange={() => {
                    setActive(!active);
                  }}
                />
              </SwitchStack>

              <Stack direction="row" justifyContent={"flex-end"}>
                <Search>
                  <SearchBox
                    variant="standard"
                    autoComplete="off"
                    placeholder={
                      isMobile
                        ? "Search Text"
                        : "Search by Hotel ID, Name or Location"
                    }
                    InputProps={{ disableUnderline: true }}
                    value={searched}
                    onChange={(e) => requestSearch(e.target.value)}
                    onCancelSearch={() => cancelSearch()}
                  />
                  <StyledSearchIcon
                    style={{
                      justifyContent: "flex-end",
                      color: "#306FBC",
                      marginTop: "8px",
                      position: "absolute",
                    }}
                  />
                </Search>
              </Stack>

              <Stack>
                <LoadingButton
                  variant="outlined"
                  loading={isDownloadExcel}
                  onClick={downloadAllHotelDetailsExcel}
                  sx={{
                    color: "#2F6FBC",
                    border: `1px solid grey`,
                    borderRadius: "8px",
                    boxShadow:
                      "0px 3px 1px -2px rgba(48, 111, 188, 0.2), 0px 2px 2px rgba(48, 111, 188, 0.2), 0px 1px 5px rgba(48, 111, 188, 0.2)",
                  }}
                >
                  <Download />
                </LoadingButton>
              </Stack>

              {addHotel && (
                <CustomButtonContainer
                  style={{
                    background: "#2F6FBC",
                    boxShadow:
                      "0px 3px 1px -2px rgba(48, 111, 188, 0.2), 0px 2px 2px rgba(48, 111, 188, 0.2), 0px 1px 5px rgba(48, 111, 188, 0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <Link to="/hotel" style={{ color: "#ffffff" }}>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <AddOutlined
                        style={{
                          width: "20px",
                          color: "white",
                        }}
                      />
                      <AddHotel> Add Hotel</AddHotel>
                    </Box>
                  </Link>
                </CustomButtonContainer>
              )}
            </Stack>
          </CustomMain>

          {!Loading ? (
            <>
              <OrganizationSection style={{ marginTop: "0px", padding: "0px" }}>
                <Paper
                  style={{
                    overflow: "auto",
                    maxHeight: "calc(100vh - 280px)",
                  }}
                >
                  <TableContainer style={{ overflow: "visible" }}>
                    <Table className="table">
                      <TableHead
                        sx={{
                          position: "sticky",
                          zIndex: 1,
                        }}
                      >
                        <TableRow className="header">
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Hotel ID
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Hotel Name
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            City
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Services
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            BOB
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Rate Comparison
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Last Night Actual
                          </TableCellHeading>

                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Hotel created Date
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Status
                          </TableCellHeading>
                          <TableCellHeading
                            style={{
                              backgroundColor: "#306fbc",
                              color: "#ffffff",
                            }}
                            align="center"
                          >
                            Download
                          </TableCellHeading>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {hotelList
                          ?.sort((a, b) => {
                            const dateA = new Date(a.createdAt);
                            const dateB = new Date(b.createdAt);
                            return dateB - dateA;
                          })
                          .map((hotel, hIndex) => (
                            <TableRow key={hIndex} hover className="rowhover">
                              <TCell
                                component="th"
                                scope="row"
                                style={{ textAlign: "center" }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {hotel?.hotelReferenceId || "-"}
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {hotel.name}
                                {differentOrganization
                                  ? " (" + hotel.organizationName + ")"
                                  : ""}
                              </TCell>

                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {hotel?.city || ""}
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {renderServiceChips(hotel)}
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {showFileStatus(
                                  hotel?.isPreciumEnabled,
                                  hotel?.forecastFileStatus,
                                  "bob",
                                )}
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {hotel?.competitorFileStatus ? (
                                  <RateComparsion
                                    style={{
                                      color: "#42AE40",
                                    }}
                                  >
                                    Uploaded
                                  </RateComparsion>
                                ) : (
                                  <RateComparsion
                                    style={{
                                      color: "#E13A3A",
                                    }}
                                  >
                                    Pending
                                  </RateComparsion>
                                )}
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {showFileStatus(
                                  hotel?.isPreciumEnabled,
                                  hotel?.arrStatus,
                                  "ln",
                                )}
                              </TCell>

                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  selectHotel(hotel, true);
                                }}
                              >
                                {moment(hotel.createdAt).format("DD/MM/yyyy")}
                              </TCell>

                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <Status
                                  style={{
                                    backgroundColor: !active ? "#EDE762" : "",
                                  }}
                                  onClick={() => {
                                    setOpenConfirmationDialog({
                                      open: true,
                                      hotelId: hotel.id,
                                    });
                                  }}
                                >
                                  {!active ? "Inactive" : "Active"}
                                </Status>
                              </TCell>
                              <TCell
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <LoadingButton
                                  loading={
                                    isDownloadHotelDetailsExcel === hotel?.id
                                  }
                                  onClick={() =>
                                    downloadHotelDetailsExcel(hotel?.id)
                                  }
                                >
                                  <Download />
                                </LoadingButton>
                              </TCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <TablePagination
                  sx={{
                    background: "#FFFFFF",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    "& option": {
                      textAlign: "center", // centers the dropdown options
                    },
                  }}
                  displayedRows={<p></p>}
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={3}
                  count={hotelCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    style: {
                      border: "1px solid #1063A280",
                      borderRadius: "5px",
                    },
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </OrganizationSection>
            </>
          ) : (
            <LoadingPage />
          )}

          <ConfirmationDialog
            open={!!openConfirmationDialog.open}
            handleCloseConfirmation={() =>
              setOpenConfirmationDialog({ open: false, hotelId: null })
            }
            confirmationText={`Are you sure you want to ${
              active ? "deactivate" : "activate"
            } this hotel?`}
            onSuccess={() => {
              if (deactivateHotel && openConfirmationDialog?.hotelId) {
                handleDeactivateHotel(openConfirmationDialog?.hotelId);
              }
              setOpenConfirmationDialog({ open: false, hotelId: null });
            }}
          />
        </HotelSection>
      </CustomPage>
    </ClassWrapper>
  );
}
